import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=c2aaa77a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aaa77a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2aaa77a')) {
      api.createRecord('c2aaa77a', component.options)
    } else {
      api.reload('c2aaa77a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=c2aaa77a&scoped=true&", function () {
      api.rerender('c2aaa77a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8skhky5Bv0sMw/JS/comp/Accordion.vue"
export default component.exports